var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgIconPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.25 24V0h24v24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.219 6.429v-1.46C14.219 3.936 13.338 3 12.25 3a1.968 1.968 0 0 0-1.969 1.969v1.459M14.565 11h-4.63a1.113 1.113 0 0 1-1.113-1.113V7.542c0-.615.498-1.113 1.113-1.113h4.631c.615 0 1.113.498 1.113 1.113v2.345c0 .615-.499 1.113-1.114 1.113h0zM18.75 21h-13a3.5 3.5 0 0 1-3.5-3.5h0a3.5 3.5 0 0 1 3.5-3.5h13a3.5 3.5 0 0 1 3.5 3.5h0a3.5 3.5 0 0 1-3.5 3.5z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.494 17.499a.244.244 0 1 0-.489.001.244.244 0 0 0 .489-.001M14.494 17.499a.244.244 0 1 0-.489.001.244.244 0 0 0 .489-.001M10.494 17.499a.244.244 0 1 0-.489.001.244.244 0 0 0 .489-.001M6.494 17.499a.244.244 0 1 0-.489.001.244.244 0 0 0 .489-.001",
    stroke: "#323232",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPassword);
export default __webpack_public_path__ + "static/media/icon_password.5cc72470c2edc8ad4e16119092390919.svg";
export { ForwardRef as ReactComponent };